import { useEffect } from "react";
import styles from "./in1888EnviadosOverlay.module.css";

export default function IN1888EnviadosOverlay({
  open,
  onClose,
  title,
  children,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow || "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className={styles.backdrop}>
      <div className={styles.panel}>
        <div className={styles.topBar}>
          <div className={styles.title}>{title || "IN1888 — TXT Enviados"}</div>
          <button
            type="button"
            className={styles.closeBtn}
            onClick={onClose}
            aria-label="Fechar"
          >
            ✕
          </button>
        </div>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}
